// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts`.
export { loadWalletMessages } from './wallet.catalog';
export { walletConfirmationLinesScreen, walletDetailScreen, walletInstructionLinesScreen, walletListScreen } from './wallet.screen';
export { fileLinesSearch, LEGACY_TAB_SEGMENTS, WALLET_LIST_PATH, walletDetailSearch, walletListSearch, type WalletTab } from './wallet.search';

/** As telas, carregadas sob demanda pela rota (`lazyScreen`). */
export const loadWalletScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadWalletGuides = () => import('./wallet.guide');
